import { combineReducers } from 'redux';

import phoneData from './phoneData';

export default combineReducers({
  phoneData,
});
